import * as api from 'app/api';
import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import { pender } from 'redux-pender';

const GET_RECENTLY_VIEWED_CAR_LIST = 'preDelivery.guide/GET_RECENTLY_VIEWED_CAR_LIST';
export const getRecentlyViewedCarList = createAction(GET_RECENTLY_VIEWED_CAR_LIST, api.getCarsItems);

const initialState = {
	isInit: false,
	recentlyViewedCarList: [],
};

export default handleActions(
	{
		...pender({
			type: GET_RECENTLY_VIEWED_CAR_LIST,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.isInit = true;
					draft.recentlyViewedCarList = data;
				}),
			onFailure: (state) =>
				produce(state, (draft) => {
					draft.isInit = true;
					draft.recentlyViewedCarList = [];
				}),
		}),
	},
	initialState,
);
